import { on_ready, is_elementor_edit } from 'js/utils';
import { hover_intent } from 'js/functions';
// import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';
// import { load_swiper_mobile } from 'modules/carousel/load_swiper_mobile';

import './internals.scss';

on_ready(()=>{

    if( is_elementor_edit() ) return;

    // add_to_cart_ajax_init();

    // load_swiper_mobile();
    
    // add delay on hover out - to avoid instant close/off
    hover_intent_init();

    anchor_nav();

});

function hover_intent_init(){
    document.querySelectorAll('.hover_intent').forEach(el=>{
        const duration = el.dataset.duration || 300;
        hover_intent(el, duration);
    });
} 

function anchor_nav() {
    const interval = setInterval(() => {
        const buttons = document.querySelectorAll('.anchor-nav .anchor-btn');
        if (!buttons.length) return; 

        clearInterval(interval); 

        // Set first button as default active
        buttons.forEach((btn, i) => btn.classList.remove('active'));
        buttons[0].classList.add('active');

        
        buttons.forEach(btn => {
            btn.addEventListener('click', e => {
                buttons.forEach(b => b.classList.remove('active')); 
                btn.classList.add('active');
            });
        });
    }, 50);
}